import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import StatusMonoHtmlView from './StatusHtml';
import StatusMonoReactView from './Status';
const StatusMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(StatusMonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(StatusMonoReactView, _extends({}, props));
};
StatusMonoView.displayName = 'StatusMonoView';
export default StatusMonoView;
